import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Breadcrumb, Card } from 'antd'

import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';
import TabellaRichiesteRepertorio from '../components/TabellaRichiesteRepertorio';


//import '../less/Repertorio.less';

@Wrapper({ route: 'TabellaRichiesteRepertorioRoute', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['viewRichiesteRepertorio', 'adminPermissions'])
class TabellaRichiesteRepertorioRoute extends Component {

  state = {
    loading: false,
  }

  renderTitle() {
    return 'Repertorio'
  }

  render() {

    return (
      <div>
        <Card
          style={{ marginBottom: '12px', backgroundColor: '#fff' }}
          bordered={false}
          className="shadow">
          <h3 className="sectionTitle">{this.renderTitle()}</h3>
          <p>Lista delle richieste</p>
        </Card>
        <div style={{ padding: '12px' }}>
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Repertorio</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <TabellaRichiesteRepertorio ref="listTable" {...this.props} />

      </div>
    );
  }
}

export default TabellaRichiesteRepertorioRoute;
